import React, { useEffect, useState } from 'react';
import { isEqual } from 'lodash';
import {
  Button,
} from '@tencent/spaui';
import { beaconInstance } from '../../../instrumentation/beaconSetup';
import { TotalAnalysis } from './totalAnalysis';
import { DistributeChart } from './distributeChart';
import { LeadsFollowChart } from './leadsFollowChart';
import { LeadsQualityChart } from './leadsTransChart';
import { FilterPart } from './filter';
import { startCreateTime, endCreateTime } from './commonUtil';
import { LeadsDedupPart } from '../../common/leadsDedup';
import { Common } from '../../../consts/Common';
import { PageUtil } from '../../../utils/PageUtil';

export const leftChartStyle = {
  height: '400px',
  width: '500px',
};
export const rightChartStyle = {
  height: '430px',
  width: '880px',
};
export const fullChartStyle = {
  height: '400px',
  width: '1450px',
};
export const pieChartLegendStyle = {
  bottom: '5',
  textAlign: 'center',
};
export const barChartLegendStyle = {
  bottom: '5',
  textAlign: 'center',
};

export const gridStyle = {
  left: '3%',
  right: '4%',
  bottom: '14%',
  containLabel: true,
};

export const multipleColor = ['#4080FF', '#FFAC40', '#6EDB37'];
export const singleColor = ['#4080FF'];
export const titleMargin = [5, 0, 10, 0];
export const chartRadius = ['40%', '50%'];
const filterItems = ['ownerIds', 'groupIds', 'leadsTags', 'actionSubTypes', 'leadsSources', 'startCreateTime', 'endCreateTime', 'timeUnit'];

export const AnalysisEmployeeChart = (props) => {
  const [queryParams, setQueryParams] = useState({});
  const [leadsData, setLeadsData] = useState({});
  const [leadsFollowData, setLeadsFollowData] = useState({});
  const [LeadsConversionData, setLeadsConversionData] = useState({});
  const [hideRepeatRegisterLeads, setHideRepeatLeads] = useState(PageUtil.getLeadsDedupFromStorage());
  const [extraParams, setExtraParams] = useState({});
  useEffect(() => {
    beaconInstance.onUserAction('employChart_openEmployeeChart', {
      // accountId: window.pageProps.uid,
      companyName: window.pageProps.companyName,
    });
    beaconInstance.onUserAction(
      'page_view',
      { page: '人效报表' },
    );
  }, []);
  const changeFilterAndSetInstrumentation = (filterObj) => {
    if (isEqual(filterObj, queryParams)) {
      return;
    }
    setFilterInstrumentation(filterObj);
    setQueryParams(filterObj);
  };
  const setFilterInstrumentation = (filterObj) => {
    const initFilter = {
      startCreateTime,
      endCreateTime,
      timeUnit: 'DAYS',
    };
    if (isEqual(filterObj, initFilter)) {
      return;
    }
    filterItems.forEach(item => {
      if (!isEqual(filterObj[item], queryParams[item])) {
        beaconInstance.onUserAction('employChart_change_filter', {
          accountId: window.pageProps.uid,
          companyName: window.pageProps.companyName,
          filterName: item,
          oldValue: queryParams[item],
          newValue: filterObj[item],
        });
      }
    });
  };
  const onChangeDedupStatus = (checked) => {
    setHideRepeatLeads(checked);
  };
  const getAllQueryParam = (queryParams) => {
    return { ...queryParams, hideRepeatRegisterLeads };
  }
  const getQueryParamStr = (queryParams) => {
    const filterQuery = Object.keys(queryParams).map(key => {
      const value = queryParams[key];
      return `${key}=${value}`;
    }).join('&');
    const allParams = `?accountId=${window.pageProps.uid}&${filterQuery}&hideRepeatRegisterLeads=${hideRepeatRegisterLeads}`;
    if(extraParams?.beginHour && extraParams?.endHour){
       // todo by fighting
       // allParams +=`&beginHour=${extraParams?.beginHour}&endHour=${extraParams?.endHour}`
    }
    const urlQuery = new URLSearchParams(allParams);
    const queryParam = `?${urlQuery.toString()}`;
    return queryParam;
  };
  const downloadGroupRecords = () => {
    window.location.href = Common.LEADS_ANALYSIS_DOWNLOAD_GROUP + getQueryParamStr(queryParams);
  };
  const downloadEmployeeRecords = () => {
    window.location.href = Common.LEADS_ANALYSIS_DOWNLOAD_EMPLOYEE + getQueryParamStr(queryParams);
  };
  const allQuery = getAllQueryParam(queryParams);
  return (
    <main className="main" id="analysis-data">
      <div className="card padding-normal no-margin">
        <div className="card-title">
          <div className="left">数据概览
            {/* <span className='card-title-description'>默认仅展示筛选条件下有线索明细的员工数据</span> */}
          </div>
          <div className='right'>
            <Button onClick={downloadGroupRecords} className="borderless">
              <i className="icon icon-download"></i>
              <span className="spaui-text">导出团队数据</span>
            </Button>
            <Button onClick={downloadEmployeeRecords} className="borderless">
              <i className="icon icon-download"></i>
              <span className="spaui-text">导出员工数据</span>
            </Button>
            <LeadsDedupPart
              tip='开启线索去重后，人效分析报表数据不包括带有电话重复标签的线索。'
              onChange={onChangeDedupStatus}
            />
          </div>
        </div>
        <FilterPart setQueryParams={changeFilterAndSetInstrumentation} />
        <TotalAnalysis
          queryParams={allQuery}
          leadsData={leadsData}
          leadsFollowData={leadsFollowData}
          LeadsConversionData={LeadsConversionData}
        />
      </div>
      <div className="card padding-normal">
        <div className="card-title">线索分配</div>
        <DistributeChart queryParams={allQuery} setLeadsData={setLeadsData} />
      </div>
      <div className="card padding-normal">
        <div className="card-title">线索跟进</div>
        <LeadsFollowChart queryParams={allQuery} setLeadsFollowData={setLeadsFollowData} setExtraParams={setExtraParams} />
      </div>
      <div className="card padding-normal">
        <div className="card-title">线索转化</div>
        <LeadsQualityChart queryParams={allQuery} setLeadsConversionData={setLeadsConversionData} />
      </div>
    </main>
  );
};
